import * as React from 'react';
import { SVGProps } from 'react';

const IconToolsBuildTurnSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 20C11.059 20 3 11.941 3 2"
      stroke="url(#SvgIconToolsBuildTurn_size_m__a)"
      strokeWidth={2}
    />
    <path fill="var(--color-typo-primary)" d="M22 22h-4v-4h4z" />
    <defs>
      <linearGradient
        id="SvgIconToolsBuildTurn_size_m__a"
        x1={20.5}
        y1={19}
        x2={3}
        y2={1.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.171} stopColor="#93C5E5" />
        <stop offset={1} stopColor="#93C5E5" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default IconToolsBuildTurnSizeM;
